'use strict';

(function () {
  'use strict';

  angular.module('vnext').controller('SearchResultsCtrl', SearchResultsCtrl);

  SearchResultsCtrl.$inject = ['$stateParams', '$state', 'activityRouter', 'activitySvc', 'focus', '$timeout'];

  /* @ngInject */
  function SearchResultsCtrl($stateParams, $state, activityRouter, activitySvc, focus, $timeout) {
    var vm = this;
    vm.title = 'SearchPageCtrl';
    vm.searchSuccess = searchSuccess;
    vm.filters = {};
    vm.start = activityRouter.createTrain;

    activate();

    ////////////////
    function activate() {
      vm.query = $stateParams.query;
      vm.filters.time = $stateParams.time;
      vm.filters.type = $stateParams.type;
      vm.size = $stateParams.size;
      vm.from = $stateParams.from;
      if ($stateParams.data) {
        //load results from search bar
        loadResults($stateParams.data);
      } else if (!_.isEmpty(vm.query)) {
        //user hit back button, get activities from query
        var searchBody = {
          query: vm.query,
          context: null,
          filters: null,
          size: null,
          from: null
        };
        activitySvc.search(searchBody).then(function (resp) {
          loadResults({ results: resp });
        });
      }
    }

    function searchSuccess(data) {
      // Set the query params in the URL
      $state.transitionTo('vnext.content.browse.searchresults', {
        query: data.body.query,
        type: data.body.filters.type ? data.body.filters.type.shortName : null,
        time: data.body.filters.time ? data.body.filters.time.shortName : null,
        size: data.body.size,
        from: data.body.from
      }, { notify: false });
      loadResults(data);
    }

    function loadResults(data) {
      vm.activities = [];
      if (_.get(data, 'body.query')) {
        vm.query = data.body.query;
      }

      _.each(data.results.hits.hits, function (a) {
        vm.activities.push(a._source);
      });

      updateResultsAnnounce();
    }

    function updateResultsAnnounce() {
      focus.byId('previousPage', 300);

      vm.resultsUpdated = true;
      $timeout(function () {
        return vm.resultsUpdated = false;
      }, 2000);
    }
  }
})();